import { Drawer, DrawerContent, DrawerTitle } from '@/components/ui/drawer';
import { OrderDetail } from '@/components/orders/OrderDetail';
import { Skeleton } from '@/components/ui/skeleton';
import { useOrder } from '@/hooks/useOrder';

interface OrderDetailDrawerProps {
  orderId: number | null;
  onClose: () => void;
  readOnly?: boolean;
}

export function OrderDetailDrawer({ orderId, onClose, readOnly = false }: OrderDetailDrawerProps) {
  const { data, isLoading } = useOrder(orderId);
  const open = orderId != null;

  return (
    <Drawer
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <DrawerContent className="h-[92vh] bg-background md:right-0 md:top-0 md:mt-0 md:h-full md:max-h-full md:w-[520px] md:rounded-none md:rounded-l-2xl md:border-l">
        <DrawerTitle className="sr-only">Order {orderId ?? ''}</DrawerTitle>
        {isLoading || !data ? (
          <div className="space-y-4 p-6">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-12 w-32" />
            <Skeleton className="h-6 w-24 rounded-full" />
            <div className="dotted-rule my-4" />
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
            <div className="dotted-rule my-4" />
            <Skeleton className="h-8 w-48" />
          </div>
        ) : (
          <OrderDetail order={data} readOnly={readOnly} onClose={onClose} />
        )}
      </DrawerContent>
    </Drawer>
  );
}
